module.exports = __webpack_public_path__ + "img/linovelib.c10f2b8d.svg";